<template>
  <j-modal
    :title="title"
    width="40%"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }"
    @ok="handleOk"
    @cancel="handleCancel"
    :okText="$t('确定')"
    :cancelText="$t('关闭')"
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
  >
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-divider orientation="left">{{ $t('节点信息') }}</a-divider>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-descriptions :column="2">
                <a-descriptions-item :label="$t('节点代码')"> {{ model.node && model.node.code }} </a-descriptions-item>
                <a-descriptions-item :label="$t('节点名称')"> {{ model.node && model.node.name }} </a-descriptions-item>
                <a-descriptions-item :label="$t('节点类型')">
                  {{ filterDictTextByCache('node_type', model.node && model.node.type) }}
                </a-descriptions-item>
              </a-descriptions>
            </a-col>
          </a-row>
          <a-divider orientation="left">{{ $t('物联信息') }}</a-divider>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item>
                <a-button type="primary" @click="handleSelectIot">{{ $t('选择物联设备') }}</a-button>
                <span v-if="getDeviceId()" style="margin-left: 12px; color: #1890ff;">
                  {{ $t('已选:') }} {{ getDeviceId() }}
                  <span v-if="getDeviceName()">({{ getDeviceName() }})</span>
                </span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <template v-if="!model.nodeIotConfig">
            <a-row :gutter="24">
              <a-col :span="24">
                <a-descriptions :column="2">
                  <a-descriptions-item :label="$t('物联代码')"> {{ getDeviceId() }} </a-descriptions-item>
                  <a-descriptions-item :label="$t('物联名称')"> {{ getDeviceName() }} </a-descriptions-item>
                </a-descriptions>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="24">
                <a-form-model-item :label="$t('转换系数')" prop="conversionCoefficient">
                  <a-input v-model="model.conversionCoefficient" :placeholder="$t('请输入转换系数')"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
          </template>
          <template v-else>
            <a-row :gutter="24">
              <a-col :span="24">
                <a-descriptions :column="2">
                  <a-descriptions-item :label="$t('物联代码')">
                    {{ model.nodeIotConfig && model.nodeIotConfig.deviceId }}
                  </a-descriptions-item>
                  <template v-if="model.node.type == 'NODE_PIPELINE_TYPE_PM'">
                    <a-descriptions-item :label="$t('最新上报时间')">
                      {{ model.iotData && model.iotData.metertime }}
                    </a-descriptions-item>
                    <a-descriptions-item :label="$t('压力')">
                      {{ model.iotData && model.iotData.pvalue }}
                    </a-descriptions-item>
                    <a-descriptions-item :label="$t('温度')">
                      {{ model.iotData && model.iotData.tepvalue }}
                    </a-descriptions-item>
                    <a-descriptions-item :label="$t('电压')">
                      {{ model.iotData && model.iotData.battery }}
                    </a-descriptions-item>
                    <a-descriptions-item :label="$t('信号')">
                      {{ model.iotData && model.iotData.signDb }}
                    </a-descriptions-item>
                  </template>
                  <template v-else-if="model.node.type == 'NODE_PIPELINE_TYPE_METER'">
                    <a-descriptions-item :label="$t('表编号')">
                      {{ model.iotData && model.iotData.meterId }}
                    </a-descriptions-item>
                    <a-descriptions-item :label="$t('最新上报时间')">
                      {{ model.iotData && model.iotData.sysTime }}
                    </a-descriptions-item>
                    <a-descriptions-item :label="$t('累计用量')">
                      {{ model.iotData && model.iotData.meterTotalUse }}
                    </a-descriptions-item>
                    <a-descriptions-item :label="$t('结算日流量')">
                      {{ model.iotData && model.iotData.meterJsrUse }}
                    </a-descriptions-item>
                    <a-descriptions-item :label="$t('表端剩余金额')">
                      {{ model.iotData && model.iotData.meterRemainNum }}
                    </a-descriptions-item>
                    <a-descriptions-item :label="$t('电压')">
                      {{ model.iotData && model.iotData.meterBatteryVoltage }}
                    </a-descriptions-item>
                    <a-descriptions-item :label="$t('信号')">
                      {{ model.iotData && model.iotData.meterSignalStrength }}
                    </a-descriptions-item>
                  </template>
                </a-descriptions>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="24">
                <a-form-model-item :label="$t('转换系数')" prop="conversionCoefficient">
                  <a-input v-model="model.nodeIotConfig.conversionCoefficient" :placeholder="$t('请输入转换系数')"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
          </template>
          <a-row :gutter="24" v-if="getDeviceId()">
            <a-col :span="24">
              <div id="chart" style="width: 100%; height: 300px"></div>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
    <IotListModal ref="IotListModalRef" @ok="callback" />
  </j-modal>
</template>
  
  <script>
import { httpAction, postAction } from '@/api/manage'
import IotListModal from './IotListModal.vue'
import JSearchSelectTag from '../../../../components/dict/JSearchSelectTag.vue'
import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
import echarts from 'echarts'
import moment from 'moment'
export default {
  name: 'modal',
  components: {
    IotListModal,
    JSearchSelectTag,
  },
  data() {
    return {
      filterDictTextByCache: filterDictTextByCache,
      width: 800,
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      model: {},
      // 标记是否已有绑定（区分"更新绑定"和"新建绑定"）
      hasExistingBinding: false,
      // 记录原有绑定的id（用于更新已有绑定）
      existingConfigId: null,
      url: {
        edit: '/jeecg-gis/nodeIotConfig/edit',
        getIotDataCurve: '/jeecg-gis/nodeIotConfig/getIotDataCurve',
      },
      iotModel: {},
    }
  },
  computed: {
    title() {
      return this.$t('编辑')
    },
    // i18n：校验规则使用 computed 以响应语言切换
    validatorRules() {
      return {
        conversionCoefficient: [{ required: true, message: this.$t('请输入转换系数') }],
      }
    },
  },
  methods: {
    // 统一获取设备ID（兼容多种数据结构）
    getDeviceId() {
      if (!this.iotModel) return null
      const m = this.iotModel
      return m.deviceId
        || (m.device && (m.device.deviceId || m.device.meterId || m.device.id))
        || (m.iotData && m.iotData.meterId)
        || m.meterId
        || m.id
        || null
    },
    getDeviceName() {
      if (!this.iotModel) return null
      const m = this.iotModel
      return (m.device && m.device.deviceName)
        || m.deviceName
        || null
    },
    handleSelectIot() {
      this.$refs.IotListModalRef.init(this.model)
    },
    init(row) {
      this.visible = true
      this.model = JSON.parse(JSON.stringify(row))
      // 重置绑定状态
      this.hasExistingBinding = false
      this.existingConfigId = null
      if (this.model.nodeIotConfig) {
        this.hasExistingBinding = true
        this.existingConfigId = this.model.nodeIotConfig.id
        this.iotModel = this.model.nodeIotConfig
        this.$nextTick(() => {
          this.getData()
        })
      } else {
        this.iotModel = {}
      }
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
    handleOk() {
      // 校验是否选择了物联设备
      if (!this.getDeviceId()) {
        this.$message.warning(this.$t('请选择物联设备'))
        return
      }
      // 校验转换系数
      const coefficient = this.model.nodeIotConfig
        ? this.model.nodeIotConfig.conversionCoefficient
        : this.model.conversionCoefficient
      if (!coefficient) {
        this.$message.warning(this.$t('请输入转换系数'))
        return
      }

      this.confirmLoading = true
      const params = {
        nodeCode: this.model.node.code,
        projectCode: this.model.node.projectCode,
        deviceId: this.getDeviceId(),
        conversionCoefficient: coefficient,
      }
      // 已有绑定时传id，后端走更新；新建绑定时无id，后端走新增
      if (this.hasExistingBinding && this.existingConfigId) {
        params.id = this.existingConfigId
      }
      console.log('提交参数：',this.existingConfigId,this.hasExistingBinding, params)
      postAction(this.url.edit, params)
        .then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.$emit('ok')
            this.visible = false
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    callback(item) {
      this.iotModel = Object.assign({}, item)
      // nodeIotConfig 清空后模板切换到"未绑定"分支，显示转换系数输入框
      this.$set(this.model, 'nodeIotConfig', null)
      this.getData()
    },
    getData() {
      if (this.getDeviceId()) {
        let params = {
          deviceId: this.getDeviceId(),
          nodeType: this.model.node.type,
          begin: moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'),
          end: moment().format('YYYY-MM-DD HH:mm:ss'),
        }
        postAction(this.url.getIotDataCurve, params).then(res => {
          if (res.success) {
            this.setChartData(res.result)
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    setChartData(data) {
      let xdata = []
      let ydata = []
      data.curveDataList.map(item => {
        xdata.push(item.time)
        ydata.push(item.value)
      })
      var chart = document.getElementById('chart')
      var myChart = echarts.init(chart)
      var option = {
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          left: '8%',
          right: '8%',
          bottom: '20%',
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: 'none',
            },
            dataView: { readOnly: false },
            magicType: { type: ['line', 'bar'] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xdata,
          splitLine: {
            // X轴网格线
            show: true,
            lineStyle: {
              color: '#999',
              type: 'dashed',
            },
          },
        },
        yAxis: {
          type: 'value',
          min: data.min,
          max: data.max,
          splitLine: {
            // Y轴网格线
            show: true,
            lineStyle: {
              color: '#999',
              type: 'dashed',
            },
          },
        },
        dataZoom: [
          {
            type: 'inside',
          },
          {
            type: 'slider',
          },
        ],
        series: [
          {
            type: 'line',
            data: ydata,
          },
        ],
      }
      myChart.setOption(option)
      window.addEventListener('resize', function () {
        myChart.resize()
      })
    },
  },
}
</script>